import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  getTenantPrefix,
  resolveTenantIdFromBrowser,
} from "@/utils/tenant";

export function useTenant() {
  const route = useRoute();
  const store = useStore();

  const tenantId = computed(() => {
    const fromRoute = route.params?.tenantPrefix;
    if (fromRoute) return String(fromRoute);
    return getTenantPrefix() || resolveTenantIdFromBrowser() || "";
  });

  const selectedTenant = computed(
    () => store.getters["tenantId/getSelectedTenant"]
  );

  const tenantName = computed(() => selectedTenant.value?.name || "");

  const user = computed(() => store.getters["tenantId/getUser"]);

  const userFirstName = computed(() => user.value?.firstName || "");

  const userFullName = computed(() => {
    if (user.value?.firstName && user.value?.lastName) {
      return `${user.value.firstName} ${user.value.lastName}`;
    }
    return user.value?.firstName || "";
  });

  function tenantPath(rest) {
    const id = tenantId.value;
    const suffix = String(rest || "").replace(/^\//, "");
    return `/${id}/${suffix}`;
  }

  return {
    tenantId,
    selectedTenant,
    tenantName,
    user,
    userFirstName,
    userFullName,
    tenantPath,
  };
}
